"use strict"

import {
    default as React,
    Component,
} from 'react';
import PropTypes from 'prop-types';

import Axis from './axis';
import Label from './label';
import CommonProps from '../commonProps';

export default class YAxis extends Component {
    constructor (props) {
        super(props);
    }

    static defaultProps = {
        axisConfig: {
            show: true,
            orient: 'bottom',
            className: 'react-d3-core__axis__yAxis',
            label: {
                show: false,
                title: '',
                position: 'left',
                offset: 0,
                hShift: 0,
                vShift: 0,
                rotate: 0,
                className: '',
            },
            ticks: {
                sizeInner: 6,
                sizeOuter: 6,
                values: null,
                format: '%',
                count: null,
                padding: 3,
                orient: 'left',
                tickClassName: '',
                tickLabelClassName: '',
            },
        },
        ...CommonProps
    };

    static propTypes = {
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
        y: PropTypes.func,
        yDomain: PropTypes.array,
        yRange: PropTypes.array,
        scaleSet: PropTypes.func,
        axisConfig: PropTypes.shape({
            show: PropTypes.bool,
            orient: PropTypes.oneOf(['left', 'right']),
            className: PropTypes.string,
            label: PropTypes.shape({
                show: PropTypes.bool,
                title: PropTypes.string,
                position: PropTypes.string,
                offset: PropTypes.number,
                hShift: PropTypes.number,
                vShift: PropTypes.number,
                rotate: PropTypes.number,
                className: PropTypes.string,
            }),
            ticks: PropTypes.shape({
                sizeInner: PropTypes.number,
                sizeOuter: PropTypes.number,
                values: PropTypes.array,
                format: PropTypes.func,
                count: PropTypes.number,
                padding: PropTypes.number,
                orient: PropTypes.oneOf(['left', 'right']),
                tickClassName: PropTypes.string,
                tickLabelClassName: PropTypes.string,
            }),
        }),
    };

    render() {
        let {
            height,
            width,
            margins,
            scaleSet,
            y,
            axisConfig,
        } = this.props;

        let t;
        let axisLabel;

        if (axisConfig.orient === 'right') {
            // y - right
            t = `translate(${(width - margins.right - margins.left + (axisConfig.hShift ? axisConfig.hShift : 0))},
                ${(axisConfig.vShift ? axisConfig.vShift : 0)})`;
        } else if (axisConfig.orient === 'left'){
            // y - left
            t = `translate(${(axisConfig.hShift ? axisConfig.hShift : 0)},
                ${(axisConfig.vShift ? axisConfig.vShift : 0)})`;
        }

        if(axisConfig.label.show) {
            axisLabel = <Label
                height= {height}
                width= {width}
                margins= {margins}
                labelTitle={axisConfig.label.title}
                labelPosition= {axisConfig.label.position}
                labelOffset= {axisConfig.label.offset}
                labelClassName={axisConfig.label.className}
                labelHShift={axisConfig.label.hShift}
                labelVShift={axisConfig.label.vShift}
                labelRotate={axisConfig.label.rotate}
            />
        }

        return (
            <g transform= {t}>
                <Axis
                    showAxis={axisConfig.show}
                    height= {height}
                    width= {width}
                    margins= {margins}
                    scaleSet = {scaleSet}
                    type = "y"
                    proxy = {y}
                    tickConfig={axisConfig.ticks}
                    customStyle={axisConfig.customStyle}
                    axisClassName= {axisConfig.className}
                    orient={axisConfig.orient}
                />
                {axisLabel}
            </g>
        )
    }
}
